<template>

    <section>
        <!-- ここから -->

        <div class="no-image-card md_no-image">
        </div>

        <!-- ここまで -->
    </section>

</template>

<style>
    /* 解説のための demo css 実際は不要です。 --------------------------------*/
    .no-image-card {
        width: 33.333%;
        padding-top: 30%;
    }
</style>

<script>

    //Svg
    import SvgIconCheck from '@/components/EndUser/svg/SvgIconCheck'

    export default {
        components: {
            SvgIconCheck,
        },
    }
</script>

